import { httpClient } from '@/network/clientController'

/** Get Operators List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operators
*/
export const getOperatorsList = () => {
    return httpClient({
		method: 'GET',
		url: 'operators',
		isCancellable: true
	})
}

/** Get Operator Detail
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operators%7Bid%7D
*/
export const getOperatorDetail = (payload) => {
    return httpClient({
		method: 'GET',
		url: `operators/${payload}`,
		isCancellable: true
	})
}

/** Reset Operator Password
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_operators%7Bid%7DresetPassword
*/
export const resetOperatorPassword = (payload) => {
    return httpClient({
		method: 'POST',
		url: `operators/${payload}/resetPassword`
	})
}

/** Delete Operator
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/DELETE_operators%7Bid%7D
*/
export const deleteOperator = (payload) => {
    return httpClient({
		method: 'DELETE',
		url: `operators/${payload}`,
		operationTypeId: 504 /* for mocks handling of tokens */
	})
}

/** Create Operator
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_operators
*/
export const createOperator = (payload) => {
    return httpClient({
		method: 'POST',
		url: 'operators',
		data: payload,
		operationTypeId: 501 /* for mocks handling of tokens */
	})
}

/** Edit/Block/Unblock Operator
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_operators%7Bid%7D
*/
export const editOperator = (payload) => {
    return httpClient({
		method: 'PUT',
		url: `operators/${payload.id}`,
		data: payload.data,
		operationTypeId: 503 /* for mocks handling of tokens */
	})
}

/** Get Operators Profiles List
@docs Não há
*/
export const getOperatorsProfilesList = () => {
    return httpClient({
		method: 'GET',
		url: 'operators/profile',
		isCancellable: true
	})
}
